( function( $ ) {
  $( document ).on( 'click', '.__custom_list_links .__mobile_links .hamburger', function() {
    if( $( this ).hasClass( 'is-active' ) ) {
      $( this ).removeClass( 'is-active' );
    } else {
      $( this ).addClass( 'is-active' );
    }

    $( '.__custom_list_links .__mobile_links ul' ).slideToggle();
  } );
} ) ( jQuery );